import { Box, ListItemText } from "@mui/material";
import { CUSTOM_RADII } from "Theme/Shape";

interface ILabelBox {
  primary: string;
  secondary: string;
  hideBorder?: boolean;
}

export const LabelBox: React.FC<ILabelBox> = (props) => {
  const { primary, secondary, hideBorder } = props;
  return (
    <Box
      sx={(theme) => ({
        border: hideBorder ? "none" : `1px solid ${theme.palette.grey[300]}`,
        px: hideBorder ? 0 : 2,
        py: hideBorder ? 0 : 1,
        borderRadius: CUSTOM_RADII.subtle,
        minWidth: "150px",
      })}
    >
      <ListItemText
        primary={primary}
        secondary={secondary}
        sx={{
          my: 0,
        }}
        slotProps={{
          secondary: {
            variant: "body1",
          },
        }}
      />
    </Box>
  );
};
